/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productpriceforuser3Inputs */

const en__field_productpriceforuser3 = /** @type {(inputs: _Field_Productpriceforuser3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price for user`)
};

const de__field_productpriceforuser3 = /** @type {(inputs: _Field_Productpriceforuser3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis für Nutzer`)
};

/**
* | output |
* | --- |
* | "Price for user" |
*
* @param {_Field_Productpriceforuser3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_productpriceforuser3 = /** @type {((inputs?: _Field_Productpriceforuser3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productpriceforuser3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_productpriceforuser3(inputs)
	return de__field_productpriceforuser3(inputs)
});
export { _field_productpriceforuser3 as "_field_productPriceForUser" }